import Vapi from 'vuex-rest-api'
import _ from 'underscore'
import { languageManager } from '@/mixins/LanguageManager'

const CRUD = new Vapi({
  state: {}
})
  .post({
    action: 'getDocuments',
    path: 'api/data/documents/get',
    property: 'capsules'
  })

  .post({
    action: 'createDocument',
    path: 'api/data/documents/new',
    property: 'createDocument'
  })

  .post({
    action: 'updateDocument',
    path: 'api/data/documents/update',
    property: 'updateDocument'
  })

  .post({
    action: 'deleteDocument',
    path: 'api/data/documents/delete'
  })

  .post({
    action: 'getHomeCarousel',
    path: 'api/data/pageSections/get',
    property: 'homeCarousel',
    requestConfig: {
      transformRequest: function (data, headers) {
        const aggregate = buildAggregate('carrousel')
        return JSON.stringify({ aggregate })
      }
    },
    onSuccess: (state, payload, axios) => {
      state.homeCarousel = transformRAW(payload.data[0])
    }
  })
  .post({
    action: 'getHomeImageDock',
    path: 'api/data/pageSections/get',
    property: 'homeImageDock',
    requestConfig: {
      transformRequest: function (data, headers) {
        const aggregate = buildAggregate('imageDock')
        return JSON.stringify({ aggregate })
      }
    },
    onSuccess: (state, payload, axios) => {
      state.homeImageDock = transformRAW(payload.data[0])
    }
  })

  .getStore()
function transformRAW (element) {
  const keys = _.keys(element)
  element = _.map(element, field => {
    if (_.isArray(field)) {
      return [
        _.map(field, el => {
          return _.object(
            _.keys(el),
            _.map(el, languageManager.methods.activeLanguage)
          )
        })
      ]
    } else return field
  })
  return _.object(keys, _.map(element, languageManager.methods.activeLanguage))
}
function buildAggregate (type) {
  return [
    { $match: { type, 'status': 'enabled' } },
    { $addFields: { _id: { $toString: '$_id' } } },
    {
      $lookup: {
        from: 'pagesectionelements',
        localField: '_id',
        foreignField: 'parent',
        as: 'elements'
      }
    },
    {
      $addFields: {
        elements: {
          $filter: {
            input: '$elements',
            as: 'element',
            cond: { $eq: ['$$element.status', 'enabled'] }
          }
        }
      }
    }
  ]
}
export default CRUD
